// GenerarService.js
import http, { SERVER_URL } from "./Http";

export const GENERIC_GENERATION_ERROR =
  "Ocurrió un error al generar la sesión. Inténtalo nuevamente.";

const generarSesionStream = async ({
  payload,
  tipoSesion,
  onProgress,
  onCompleted,
  onError,
}) => {
  const token = localStorage.getItem("access_token");

  const response = await fetch(
    `${SERVER_URL}/generador-sesiones/generar-sesion?tipo_de_sesion=${tipoSesion}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        sesiones_data: payload.sesiones_data,
        estandares_ap: payload.estandares_ap ?? null,
      }),
    }
  );

  if (!response.ok) {
    throw new Error(`Error HTTP ${response.status}`);
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  while (true) {
    const { value, done } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split("\n");
    buffer = lines.pop();

    for (const line of lines) {
      if (!line.trim()) continue;

      const event = JSON.parse(line);

      if (event.event === "progress") {
        onProgress?.(event);
      }

      if (event.event === "completed") {
        onCompleted?.(event);
        return event.sessionId;
      }

      if (event.event === "error") {
        onError?.(event);
        console.error("Detalle técnico de generación:", event.message);
        throw new Error(GENERIC_GENERATION_ERROR);
      }
    }
  }
};


// Generar Word
const generarWord = async (idSesion, tipo_sesion) => {
  const res = await http.post(`/generador-sesiones/generar-word/${idSesion}/${tipo_sesion}`);
  return res.data;
};

// Generar PDF
const generarPdf = async (idSesion, tipo_sesion) => {
  const res = await http.post(`/generador-sesiones/generar-pdf/${idSesion}/${tipo_sesion}`);
  return res.data;
};

// Generar HTML
const generarHtml = async (idSesion, tipo_sesion) => {
  const res = await http.post(`/generador-sesiones/generar-html/${idSesion}/${tipo_sesion}`);
  return res.data;
};


const GenerarService = {
  generarSesionStream,
  generarWord,
  generarPdf,
  generarHtml,
};

export default GenerarService;
